export { FacebookShareButton, FacebookIcon } from "react-share";
